// Pure helpers for the tonality picker. Kept beside the component so they
// stay tightly scoped to picker UI concerns (interval labels, signature
// badges) rather than being promoted to lib/music.

import { keySignature } from "@/lib/music/key";
import type { Tonality } from "@/lib/music/tonality";

export const TRANSPOSE_RANGE = 24;
export const DONE_FLASH_MS = 1200;
export const FONT_MONO =
  "var(--font-mono), 'JetBrains Mono', ui-monospace, monospace";

export type ApplyState = "idle" | "loading" | "done";

const INTERVALS_FR = [
  "unisson",
  "seconde mineure",
  "seconde majeure",
  "tierce mineure",
  "tierce majeure",
  "quarte juste",
  "triton",
  "quinte juste",
  "sixte mineure",
  "sixte majeure",
  "septième mineure",
  "septième majeure",
  "octave",
] as const;

export function intervalLabel(semis: number): string {
  if (semis === 0) {
    return "même tonique";
  }

  const abs = Math.abs(semis);
  const arrow = semis > 0 ? "↑" : "↓";

  if (abs <= 12) {
    return `${INTERVALS_FR[abs]} ${arrow}`;
  }

  return `${semis > 0 ? "+" : ""}${semis} demi-tons ${arrow}`;
}

export function signatureBadge(t: Tonality): string | null {
  const sig = keySignature(t.tonic, t.mode);

  if (!sig || sig.count === 0) {
    return null;
  }

  return `${sig.count}${sig.accidental === "sharp" ? "♯" : "♭"}`;
}
